"use strict";
/**
 * @description 下拉菜单 Class
 * @author wangfupeng
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_core_1 = __importDefault(require("../../utils/dom-core"));
var Menu_1 = __importDefault(require("./Menu"));
var DropList_1 = __importDefault(require("./DropList"));
var DropListMenu = /** @class */ (function (_super) {
    __extends(DropListMenu, _super);
    function DropListMenu($elem, editor, conf) {
        var _this = _super.call(this, $elem, editor) || this;
        // 国际化
        conf.title = editor.i18next.t("menus.dropListMenu." + conf.title);
        // 非中文模式下 带 icon 的下拉列表居左
        var className = editor.config.lang === 'zh-CN' ? '' : 'w-e-drop-list-tl';
        if (className !== '' && conf.type === 'list') {
            conf.list.forEach(function (item) {
                var $elem = item.$elem;
                var $children = dom_core_1.default($elem.children());
                if ($children.length > 0) {
                    var nodeName = $children === null || $children === void 0 ? void 0 : $children.getNodeName();
                    if (nodeName && nodeName === 'I') {
                        $elem.addClass(className);
                    }
                }
            });
        }
        // 初始化 dropList
        var dropList = new DropList_1.default(_this, conf);
        _this.dropList = dropList;
        // 绑定事件
        $elem
            .on('mouseenter', function () {
            if (editor.selection.getRange() == null) {
                return;
            }
            $elem.css('z-index', editor.zIndex.get('menu'));
            // 触发 droplist 悬浮事件
            editor.txt.eventHooks.dropListMenuHoverEvents.forEach(function (fn) { return fn(); });
            // 显示
            dropList.showTimeoutId = window.setTimeout(function () {
                dropList.show();
            }, 200);
        })
            .on('mouseleave', function () {
            $elem.css('z-index', 'auto');
            // 隐藏
            dropList.hideTimeoutId = window.setTimeout(function () {
                dropList.hide();
            });
        });
        return _this;
    }
    return DropListMenu;
}(Menu_1.default));
exports.default = DropListMenu;
